module.exports = __webpack_public_path__ + "img/L.c51521b7.png";